import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e60c574"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["open"]
const _hoisted_2 = { class: "f-w-b" }
const _hoisted_3 = { class: "search-form_advancedLabel" }
const _hoisted_4 = { class: "grid grid--cols-2 m-t-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = { class: "flow-horizontal search-form_actions" }
const _hoisted_7 = {
  class: "button button--primary button--big",
  type: "submit"
}
const _hoisted_8 = {
  class: "button button--secondary button--big",
  type: "reset"
}

import { computed, ref, watch, withDefaults } from 'vue';
import { FieldType } from '@/types';
import FormField from '../molecules/FormField.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    fields: null,
    advancedFields: { default: () => [] },
    advancedTitle: { default: '' }
  },
  emits: ["submit", "change"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'submit', inputs: { [key: string]: string }): void;
  (e: 'change', inputs: { [key: string]: string }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { fields: FieldType[], advancedFields: FieldType[], advancedTitle: string }





const inputs = ref<{ [key: string]: string }>({});

const allFields = computed(() => [...props.fields, ...props.advancedFields]);

/**
 * Set a field to the value it starts with
 * @param {FieldType} field - field to seed
 */
const initField = (field: FieldType) => {
  if (field.initialValue) {
    inputs.value[field.key] = field.initialValue;
    return;
  }

  if (field.type === 'dropdown' && !field.allowAll) {
    inputs.value[field.key] = field.values[0].id;
    return;
  }

  inputs.value[field.key] = '';
};

allFields.value.forEach(initField);

// A field can appear once its values are known, i.e. when a year offers values for it. It starts
// out empty, as an initial value only applies to the first render of the form.
watch(allFields, (fields) => {
  fields.forEach((field) => {
    if (field.key in inputs.value) return;

    inputs.value[field.key] =
      field.type === 'dropdown' && !field.allowAll ? field.values[0].id : '';
  });
});

// Open the advanced section right away, if one of its fields is prefilled from the url
const advancedIsOpen = ref(props.advancedFields.some((field) => field.initialValue));

watch(
  inputs,
  (newValue) => {
    emit('change', newValue);
  },
  { deep: true },
);

const resetFrom = () => {
  allFields.value.forEach((field) => {
    if (field.type === 'dropdown' && !field.allowAll) {
      inputs.value[field.key] = field.values[0].id;
      return;
    }

    inputs.value[field.key] = '';

    emit('change', inputs.value);
  });
};

/**
 * Set a single field from the outside, i.e. to undo a selection which cannot be applied
 * @param {string} key - field to set
 * @param {string} value - value to set it to
 */
const setInput = (key: string, value: string) => {
  inputs.value[key] = value;
};

expose({ setInput });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "grid grid--cols-2",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('submit', inputs.value)), ["prevent"])),
    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change', inputs.value))),
    onReset: resetFrom
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
      return (_openBlock(), _createBlock(FormField, {
        key: field.key,
        modelValue: inputs.value[field.key],
        "onUpdate:modelValue": ($event: any) => ((inputs.value[field.key]) = $event),
        field: field
      }, null, 8, ["modelValue", "onUpdate:modelValue", "field"]))
    }), 128)),
    (__props.advancedFields.length)
      ? (_openBlock(), _createElementBlock("details", {
          key: 0,
          class: "search-form_advanced",
          open: advancedIsOpen.value,
          onToggle: _cache[0] || (_cache[0] = ($event: any) => (advancedIsOpen.value = ($event.target as HTMLDetailsElement).open))
        }, [
          _createElementVNode("summary", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(__props.advancedTitle) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["search-form_advancedIcon", advancedIsOpen.value ? 'newicon-40-1' : 'newicon-39-1'])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.advancedFields, (field) => {
              return (_openBlock(), _createBlock(FormField, {
                key: field.key,
                modelValue: inputs.value[field.key],
                "onUpdate:modelValue": ($event: any) => ((inputs.value[field.key]) = $event),
                field: field
              }, null, 8, ["modelValue", "onUpdate:modelValue", "field"]))
            }), 128))
          ])
        ], 40, _hoisted_1))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.$t('submitSearch')), 1),
      _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.$t('resetSearch')), 1)
    ])
  ], 32))
}
}

})